import { render, staticRenderFns } from "./LoginComponentOnboarding.vue?vue&type=template&id=57597cbd&scoped=true&"
import script from "./LoginComponentOnboarding.vue?vue&type=script&lang=js&"
export * from "./LoginComponentOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57597cbd",
  null
  
)

export default component.exports